<script setup lang="ts">
import StockInvestmentAmountSelect from './StockInvestmentAmountSelect.vue'
import IncentivesSelect from '../incentives/IncentivesSelect.vue'
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'
import { onMounted } from 'vue'
import { trackAnalyticsInvestmentProcessStep1 } from '../../../utilities/useTracking'

onMounted(() => {
    trackAnalyticsInvestmentProcessStep1()
})
</script>

<template>
    <div class="px-6 py-6">
        <StockInvestmentAmountSelect></StockInvestmentAmountSelect>
        <IncentivesSelect v-if="getCampaignData().assets_incentives.length > 0"></IncentivesSelect>
    </div>
</template>

<style scoped></style>
